import {Component, Input} from '@angular/core';
import {InputAbstract} from '../base/input.abstract';
import {GroupedSelectOptions} from '../../../../global';
import { NgIf, NgFor } from '@angular/common';
import { MatFormField, MatLabel, MatSuffix, MatHint, MatError } from '@angular/material/form-field';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { LoaderComponent } from '../../loader/loader.component';
import { MatSelect } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatOptgroup, MatOption } from '@angular/material/autocomplete';

@Component({
    selector: 'slm-grouped-select-input',
    templateUrl: './grouped-select-input.component.html',
    styles: [`
    .simple-view {
      height: 3rem;
    }

    :host {
      flex-direction: row;
      box-sizing: border-box;
      display: flex;
    }
  `],
    imports: [NgIf, MatFormField, MatLabel, TranslateDirective, LoaderComponent, MatSuffix, MatSelect, FormsModule, ReactiveFormsModule, NgFor, MatOptgroup, MatOption, MatHint, MatError, TranslatePipe]
})
export class GroupedSelectInputComponent extends InputAbstract {
  public loading = true;

  public groupedOptions: Array<GroupedSelectOptions> = null;

  @Input('options')
  public set setOptions(options: Array<GroupedSelectOptions>) {
    this.groupedOptions = options;
    this.loading = !options;
  }
}
